import React, { useEffect, useState } from 'react';
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion';
import { Row, Col, Container } from 'react-bootstrap';
import { Clock, ChevronLeft, ChevronRight } from 'react-feather';
import NotificationService from '../services/Notification';
import Loader from '../component/Loader';
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { addTotalBellItems } from '../redux/slices/countSlice';

const Notification = () => {
    const dispatch = useDispatch();
 
    const tokens = useSelector(state => state.userTypeSlice.token);
    // All UseState
    const [isRecentNotification, setIsRecentNotification] = useState("All"); 
    const [isRecentNotificationList, setIsRecentNotificationList] = useState([]);
    const [isTotalPagesRecentNotification, setTotalPagesRecentNotification] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [isReadMoreNews, setIsReadMoreNews] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [selectedShowMoreItem, setSelectedShowMoreItem] = useState('');
    const [loading, setLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);

    const formatDate = (date) => {
        return new Date(date).toLocaleString("en-GB", {
          timeZone: "UTC",
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
    };

    const handlePageClick = (selectedPage) => {
        setCurrentPage(selectedPage.selected + 1);
    };

    // All UseEffect
    useEffect(() => {
        const fetchNotificationData = async () => {
            const token = localStorage.getItem('access_token');
            const limit = 20;
            const actionRecent = isRecentNotification === "Recent" ? "Recent" : "All";
            try {
                const notificationList = await NotificationService.allNotifications(currentPage, limit, actionRecent, tokens.access);

                if (!notificationList.error) {
                    const dataList = notificationList?.data?.data || [];
                    const totalPages = notificationList?.data?.totalPages;
                    setIsRecentNotificationList(dataList);
                    setTotalPagesRecentNotification(totalPages);
                    setPageCount(dataList.length < limit ? currentPage : totalPages);
                    setLoading(false);
                }
            } catch (e) {
                console.error('Error');
            }
        };
        fetchNotificationData();
    }, [isRecentNotification, currentPage, tokens]);

    // All Functions
    const handleTabClick = (tabName) => {
        setCurrentPage(1);
        setIsRecentNotification(tabName);
    };

    const handleNewsReadMore = async (itemId) => {
        setSelectedShowMoreItem(itemId);
        setIsReadMoreNews(!isReadMoreNews);
        const token = localStorage.getItem('access_token');
        const payload = {
            notificationId: itemId,
        };
        const NotificationReadMore = await NotificationService.readNotification(payload, token);
        if (NotificationReadMore.error === false) {
            const updatedList = isRecentNotificationList.map((item) => {
                if (item.id === itemId) {
                    return { ...item, has_viewed: '1' };
                }
                return item;
            });
            const NotificationResponse = await NotificationService.totalUnreadNotifications();
            if(NotificationResponse.error == false)
                dispatch(addTotalBellItems({bellCount:NotificationResponse.data["unread-notification"]}))
            setIsRecentNotificationList(updatedList);
        }
    };

    return (
        <>
            <BreadCrumbSecttion pageTitle="Notification" currentPageName="Notification" />
            <section className='padTop50'>
                <Container>
                    <Row>
                        <Col xs={12}>
                            <div className='notificationTabList'>
                                <ul>
                                    {/* <li className={isRecentNotification === "Recent" ? 'active' : ''} onClick={() => handleTabClick('Recent')}>
                                        Recent
                                    </li> */}
                                    <li className={isRecentNotification === "All" ? 'active' : ''} onClick={() => handleTabClick('All')}>
                                        All
                                    </li>
                                    <li className={isRecentNotification === "Recent" ? 'active' : ''} onClick={() => handleTabClick('Recent')}>
                                        Recent
                                    </li>
                                </ul>
                            </div>
                            <div className='userInfoBox bg-transparent p-13'>
                                <div className="dashboard-details">
                                    <div className='notificationList'>
                                        <Row>
                                            <Col xs={12}>
                                                <div>
                                                    <ul>
                                                        {isRecentNotificationList?.map((item, index) => (
                                                            <li key={index} className={item.has_viewed == 0 ? 'unreadNotification' : 'readNotification'}>
                                                                <div className='notificationTitle'>
                                                                    {item.notification_message}
                                                                </div>
                                                                <div className='notificationDescription'>
                                                                    <p className='mb-2'>
                                                                        {item.notification_message}
                                                                    </p>
                                                                </div>
                                                                <div className='notificationTime'>
                                                                    <span className='clock-icon'><Clock /></span> {formatDate(item.created_at)}
                                                                </div>
                                                                <div className='readMoreNotification' onClick={() => handleNewsReadMore(item.id)}>
                                                                    <p className='mb-2'><u>View Details</u></p>
                                                                </div>
                                                                {selectedShowMoreItem === item.id && isReadMoreNews && (
                                                                    <p>{item.notification_message}</p>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className='notificationPagination mt-4'>
                                            <ReactPaginate
                                                previousLabel={<ChevronLeft />}
                                                nextLabel={<ChevronRight />}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination'}
                                                subContainerClassName={'pages pagination'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Notification;